import React, { useEffect, useState } from "react";
import styled from "styled-components";
// Mantidos (mesmo que não usados diretamente aqui) para não alterar sua estrutura
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";
import { ptBR } from "date-fns/locale";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useToast } from "../components/ToastProvider";
import {
    getFirestore,
    collection,
    getDocs,
    doc,
    getDoc,
    query,
    where,
    addDoc,
    serverTimestamp,
    deleteDoc
} from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from "../firebase";
import AgendaPage from "../components/Agenda";
import { LuChevronDown } from "react-icons/lu";
import ModalHorarioFuncionamento from "../components/ModalHorarioFuncionamento";

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
    getDay,
    locales: { "pt-BR": ptBR },
});

/* ======================= ESTILOS RESPONSIVOS ======================= */
const Main = styled.main`
  flex: 1;
  padding: 2rem 4rem;
  background-color: #f3f7ff;
  min-height: 100vh;

  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 2rem;
  align-items: start;

  @media (max-width: 1280px) { padding: 2rem; }
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 1.25rem;
    padding: 1.25rem;
  }
  @media (max-width: 640px) { padding: 1rem; }
`;

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.5rem;
  min-width: 0;
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 1.25rem;
  padding: 1.25rem;
  box-shadow: 0 4px 16px rgba(0,0,0,.06);
`;

const SectionTitle = styled.h2`
  margin: 0 0 1rem 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1F1A40;

  @media (max-width: 640px) { font-size: 1.1rem; }
`;

const RowBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: .75rem;
  flex-wrap: wrap;
`;

const CalendarWrapper = styled.div`
  /* estilos globais do react-big-calendar */
  .rbc-calendar {
    border-radius: 1rem;
    box-shadow: none;
    height: 60vh;
  }
  .rbc-toolbar {
    color: white;
    padding: 0.75rem 1rem;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: .5rem;
    flex-wrap: wrap;
    border-radius: .75rem .75rem 0 0;
  }
  .rbc-event {
    background-color: #3a79ed !important;
    border-radius: 8px;
    padding: 4px;
    font-weight: 500;
  }

  @media (max-width: 1024px) {
    .rbc-calendar { height: 56vh; }
  }
  @media (max-width: 640px) {
    .rbc-calendar { height: 66vh; }
  }
`;

const IntervaloForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  label {
    font-weight: 600;
    color: #1F1A40;
    margin-bottom: 0.35rem;
  }

  select, input[type='date'] {
    padding: 0.6rem 1rem;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 1rem;
    background-color: #fff;
    color: #1F1A40;
    outline: none;
  }

  button[type="submit"] {
    align-self: flex-start;
    padding: 0.7rem 1.2rem;
    border-radius: 10px;
    background-color: #3a79ed;
    color: white;
    border: none;
    font-weight: 700;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color .2s ease;
  }
  button[type="submit"]:hover { background-color: #2f66cb; }
`;

const DeleteButton = styled.button`
  padding: 0.55rem 0.9rem;
  border-radius: 10px;
  background-color: #ed3a3a;
  color: white;
  border: none;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color .2s ease;

  &:hover { background-color: #d43232; }
`;

const EditarButton = styled.button`
  padding: 0.55rem 0.9rem;
  border-radius: 10px;
  background-color: #3a79ed;
  color: white;
  border: none;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color .2s ease;

  &:hover { background-color: #2f66cb; }
`;

const ToggleHeader = styled.button`
  margin-top: 2rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: .5rem;
  align-items: center;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: .25rem 0;
`;

const ChevronIcon = styled(LuChevronDown)`
  transition: transform 0.3s ease;
  transform: ${({ rotated }) => (rotated ? "rotate(180deg)" : "rotate(0deg)")};
`;

const IntervalosContainer = styled.div`
  max-height: ${({ expanded }) => (expanded ? "320px" : "0")};
  overflow-y: auto;
  transition: max-height 0.3s ease;
  padding-right: 4px;

  /* scrollbar leve */
  scrollbar-width: thin;
  &::-webkit-scrollbar { height: 6px; width: 6px; }
  &::-webkit-scrollbar-thumb { background: #e5e7eb; border-radius: 999px; }
  &::-webkit-scrollbar-track { background: transparent; }
`;

const IntervaloCard = styled.div`
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  padding: 1rem 1.2rem;
  margin-top: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: .75rem;

  .pill {
    margin-left: .5rem;
    font-size: .75rem;
    padding: .2rem .5rem;
    border-radius: .5rem;
    font-weight: 700;
  }
  .pill-fixed { background: #3a79ed; color: #fff; }
  .pill-date  { background: #e1ecff; color: #3a79ed; }
`;

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const SwitchText = styled.span`
  font-weight: 600;
  color: #1F1A40;
`;

const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
`;

const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span { background-color: #3a79ed; }
  &:checked + span:before { transform: translateX(24px); }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #d1d5db;
  transition: 0.3s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 4px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`;

/* ======================= COMPONENTE ======================= */
export default function AgendaComIntervalo() {
    const [eventos, setEventos] = useState([]);
    const [horaInicio, setHoraInicio] = useState("08:00");
    const [horaFim, setHoraFim] = useState("18:00");
    const [intervaloInicio, setIntervaloInicio] = useState("");
    const [intervaloFim, setIntervaloFim] = useState("");
    const [barbeariaId, setBarbeariaId] = useState(null);
    const [barbeiroId, setBarbeiroId] = useState(null);
    const [intervalos, setIntervalos] = useState([]);
    const [mostrarIntervalos, setMostrarIntervalos] = useState(false);
    const [intervaloFixo, setIntervaloFixo] = useState(true);
    const [dataEspecifica, setDataEspecifica] = useState("");
    const [mostrarModalHorario, setMostrarModalHorario] = useState(false);
    const [formHorario, setFormHorario] = useState(null);
    const [horarioFuncionamentoBarbearia, setHorarioFuncionamentoBarbearia] = useState({ inicio: "00:00", fim: "23:45" });
    const auth = getAuth(app);
    const db = getFirestore(app);
    const { show, success, error } = useToast();

    useEffect(() => {
        const buscarHorariosDoBarbeiro = async () => {
            if (!barbeariaId || !barbeiroId) return;

            const diasPadrao = ["domingo", "segunda", "terca", "quarta", "quinta", "sexta", "sabado"];
            const dados = {};
            let menorInicio = "23:59";
            let maiorFim = "00:00";

            const barbeiroRef = collection(db, `barbearia/${barbeariaId}/barbeiros/${barbeiroId}/horarioFuncionamento`);
            const barbeiroSnap = await getDocs(barbeiroRef);

            if (!barbeiroSnap.empty) {
                barbeiroSnap.forEach(doc => {
                    const dia = doc.id;
                    const { aberto = false, horarioInicio = "", horarioTermino = "" } = doc.data();
                    dados[dia] = { aberto, horarioInicio, horarioTermino };
                    if (aberto && horarioInicio && horarioTermino) {
                        if (horarioInicio < menorInicio) menorInicio = horarioInicio;
                        if (horarioTermino > maiorFim) maiorFim = horarioTermino;
                    }
                });
            } else {
                const barbeariaRef = collection(db, `barbearia/${barbeariaId}/horarioFuncionamento`);
                const barbeariaSnap = await getDocs(barbeariaRef);
                barbeariaSnap.forEach(doc => {
                    const dia = doc.id;
                    const { aberto = false, horarioInicio = "", horarioTermino = "" } = doc.data();
                    dados[dia] = { aberto, horarioInicio, horarioTermino };
                    if (aberto && horarioInicio && horarioTermino) {
                        if (horarioInicio < menorInicio) menorInicio = horarioInicio;
                        if (horarioTermino > maiorFim) maiorFim = horarioTermino;
                    }
                });
            }

            diasPadrao.forEach((dia) => {
                if (!dados[dia]) dados[dia] = { aberto: false, horarioInicio: "", horarioTermino: "" };
            });

            if (menorInicio === "23:59" && maiorFim === "00:00") {
                menorInicio = "08:00";
                maiorFim = "18:00";
            }

            setFormHorario({ horarios: dados, faixaHorario: { inicio: menorInicio, fim: maiorFim } });
            setHorarioFuncionamentoBarbearia({ inicio: menorInicio, fim: maiorFim });
        };

        buscarHorariosDoBarbeiro();
    }, [barbeariaId, barbeiroId]);

    useEffect(() => {
        const auth = getAuth(app);
        const db = getFirestore(app);

        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (!currentUser) return;

            const uid = currentUser.uid;
            setBarbeiroId(uid);

            const barbeariasSnapshot = await getDocs(collection(db, "barbearia"));
            for (const docBarbearia of barbeariasSnapshot.docs) {
                const barbeiroRef = doc(db, `barbearia/${docBarbearia.id}/barbeiros/${uid}`);
                const barbeiroSnap = await getDoc(barbeiroRef);
                if (barbeiroSnap.exists()) {
                    setBarbeariaId(docBarbearia.id);
                    break;
                }
            }

            if (!barbeariaId) return;

            const agendamentosSnapshot = await getDocs(collection(db, `barbearia/${barbeariaId}/agendamentos`));
            const dados = [];

            agendamentosSnapshot.forEach((doc) => {
                const ag = doc.data();
                if (ag.status !== "confirmado" || ag.barbeiroId !== uid) return;

                const hora = ag.horaInicio || "00:00";
                const data = ag.data || "2025-01-01";
                const duracao = ag.duracao || 30;
                const [h, m] = hora.split(":");

                const start = new Date(`${data}T${h.padStart(2, "0")}:${m.padStart(2, "0")}:00`);
                const end = new Date(start.getTime() + duracao * 60000);

                dados.push({
                    id: doc.id,
                    title: `${ag.servicoNome || "Serviço"}\n${ag.clienteNome || "Cliente"}`,
                    start,
                    end,
                });
            });

            setEventos(dados);
        });

        return () => unsubscribe();
    }, [barbeariaId]);

    useEffect(() => {
        const auth = getAuth(app);
        const db = getFirestore(app);

        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (!user) return;

            const uid = user.uid;
            const barbeariasSnap = await getDocs(collection(db, "barbearia"));

            for (const docBarbearia of barbeariasSnap.docs) {
                const barbeiroRef = doc(db, `barbearia/${docBarbearia.id}/barbeiros/${uid}`);
                const barbeiroSnap = await getDoc(barbeiroRef);

                if (barbeiroSnap.exists()) {
                    const intervalosRef = collection(db, `barbearia/${docBarbearia.id}/barbeiros/${uid}/intervalos`);
                    const snap = await getDocs(intervalosRef);
                    const lista = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
                    setIntervalos(lista);
                    return;
                }
            }
        });

        return () => unsubscribe();
    }, []);

    async function apagarIntervalo(id) {
        if (!auth.currentUser || !barbeariaId || !barbeiroId) return;
        const ref = doc(db, `barbearia/${barbeariaId}/barbeiros/${barbeiroId}/intervalos/${id}`);
        await deleteDoc(ref);
        setIntervalos(prev => prev.filter(item => item.id !== id));
    }

    const salvarIntervalo = async (e) => {
        e.preventDefault();
        if (!barbeariaId || !barbeiroId || !intervaloInicio || !intervaloFim) return;

        const ref = collection(db, `barbearia/${barbeariaId}/barbeiros/${barbeiroId}/intervalos`);
        await addDoc(ref, {
            horaInicio: intervaloInicio,
            horaFim: intervaloFim,
            tipo: intervaloFixo ? "fixo" : "data",
            data: intervaloFixo ? null : dataEspecifica,
            createdAt: serverTimestamp(),
        });

        setIntervaloInicio("");
        setIntervaloFim("");
        setDataEspecifica("");

        const snap = await getDocs(ref);
        const lista = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setIntervalos(lista);

        success("Intervalo cadastrado com sucesso!");
    };

    function gerarHorarios() {
        const horarios = [];
        const [inicioH, inicioM] = horarioFuncionamentoBarbearia.inicio.split(":").map(Number);
        const [fimH, fimM] = horarioFuncionamentoBarbearia.fim.split(":").map(Number);

        const inicioMin = inicioH * 60 + inicioM;
        const fimMin = fimH * 60 + fimM;

        for (let min = inicioMin; min <= fimMin; min += 15) {
            const h = String(Math.floor(min / 60)).padStart(2, "0");
            const m = String(min % 60).padStart(2, "0");
            horarios.push(<option key={`${h}:${m}`} value={`${h}:${m}`}>{h}:{m}</option>);
        }
        return horarios;
    }

    return (
        <>
            <Main>
                {/* Coluna da Agenda */}
                <Stack>
                    <Card>
                        <CalendarWrapper>
                            <AgendaPage />
                        </CalendarWrapper>
                    </Card>
                </Stack>

                {/* Coluna de Controles */}
                <Stack>
                    <Card>
                        <RowBetween>
                            <SectionTitle style={{ margin: 0 }}>Gerenciar horários</SectionTitle>
                            <EditarButton onClick={() => setMostrarModalHorario(true)}>Editar</EditarButton>
                        </RowBetween>

                        {formHorario && (
                            <ModalHorarioFuncionamento
                                isOpen={mostrarModalHorario}
                                onClose={() => setMostrarModalHorario(false)}
                                form={formHorario}
                                setForm={setFormHorario}
                                barbeiroId={barbeiroId}
                                barbeariaId={barbeariaId}
                            />
                        )}
                    </Card>

                    <Card>
                        <SectionTitle>Adicionar Intervalo</SectionTitle>

                        <IntervaloForm onSubmit={salvarIntervalo}>
                            <SwitchWrapper>
                                <SwitchText>Intervalo para Data Específica</SwitchText>
                                <ToggleSwitch>
                                    <ToggleInput
                                        type="checkbox"
                                        checked={!intervaloFixo}
                                        onChange={() => setIntervaloFixo(!intervaloFixo)}
                                    />
                                    <Slider />
                                </ToggleSwitch>
                            </SwitchWrapper>

                            {!intervaloFixo && (
                                <div>
                                    <label htmlFor="data">Data específica</label><br />
                                    <input
                                        style={{ marginTop: 10 }}
                                        type="date"
                                        id="data"
                                        value={dataEspecifica}
                                        onChange={(e) => setDataEspecifica(e.target.value)}
                                        required={!intervaloFixo}
                                    />
                                </div>
                            )}

                            <div>
                                <label htmlFor="inicio">Início</label><br />
                                <select
                                    style={{ marginTop: 10 }}
                                    id="inicio"
                                    value={intervaloInicio}
                                    onChange={(e) => setIntervaloInicio(e.target.value)}
                                    required
                                >
                                    <option value="">--</option>
                                    {gerarHorarios()}
                                </select>
                            </div>

                            <div>
                                <label htmlFor="fim">Fim</label><br />
                                <select
                                    style={{ marginTop: 10 }}
                                    id="fim"
                                    value={intervaloFim}
                                    onChange={(e) => setIntervaloFim(e.target.value)}
                                    required
                                >
                                    <option value="">--</option>
                                    {gerarHorarios()}
                                </select>
                            </div>

                            <button type="submit">Salvar</button>
                        </IntervaloForm>

                        <ToggleHeader onClick={() => setMostrarIntervalos(!mostrarIntervalos)}>
                            <h4 style={{ margin: 0, fontWeight: 800, fontSize: "1rem", color: '#1F1A40' }}>Meus Intervalos</h4>
                            <ChevronIcon size={20} rotated={mostrarIntervalos ? 1 : 0} />
                        </ToggleHeader>

                        <IntervalosContainer expanded={mostrarIntervalos}>
                            {intervalos.length === 0 && (
                                <p style={{ marginTop: "1rem" }}>Nenhum intervalo cadastrado.</p>
                            )}

                            {intervalos
                                .filter((intervalo) => {
                                    if (intervalo.tipo === "fixo") return true;
                                    const data = intervalo.data;
                                    if (!data) return false;
                                    const hoje = new Date();
                                    const dataIntervalo = new Date(`${data}T23:59:59`);
                                    return dataIntervalo >= hoje;
                                })
                                .map((intervalo) => (
                                    <IntervaloCard key={intervalo.id}>
                                        <div>
                                            <span>
                                                {intervalo.horaInicio} - {intervalo.horaFim}
                                                {intervalo.tipo === "fixo" ? (
                                                    <span className="pill pill-fixed">fixo</span>
                                                ) : (
                                                    <span className="pill pill-date">
                                                        {new Date(intervalo.data).toLocaleDateString("pt-BR")}
                                                    </span>
                                                )}
                                            </span>
                                        </div>
                                        <DeleteButton onClick={() => apagarIntervalo(intervalo.id)}>Apagar</DeleteButton>
                                    </IntervaloCard>
                                ))}
                        </IntervalosContainer>
                    </Card>
                </Stack>
            </Main>
        </>
    );
}
